'use strict';

var config = require('../config');
var ActionFactory = require('./Action');

/**
 * Factory used to initialize and manage collections of actions. Assumes that 
 * collection are unique within the same dispatcher.
 */

var ActionsUtil = function ($injector) {

  var cache = {}; // Existing Action Collections
  var Action = $injector.invoke(ActionFactory);

  function Actions (id, dispatcherId) {
    this.$id = id;
    this.$dispatcherId = dispatcherId || Actions.getDefaultDispatcherId();
  }

  Actions.getDefaultDispatcherId = function () {
    return config.DISPATCHER_ID;
  };

  Actions.prototype = {

    /**
     * Add an Action to this collection
     * 
     * @param  {Object} definition Action definition
     * @return {Object} Action instance
     */
    add: function (definition) {
      var action = this[definition.name];
      
      if (!action) {
        var namespace = this.$id;
        var dispatcherId = this.$dispatcherId;
        
        action = Action.create(namespace, dispatcherId, definition);
        this[definition.name] = action;
      }

      return action; 
    },
  };

  return {

    /**
     * Create a new Actions collection if it doesn't exist
     * 
     * @param  {[type]} def [description]
     * @return {[type]}     [description]
     */
    create: function (id, dispatcherId) {
      var actions = cache[id];

      if (!actions) {
        actions = new Actions(id, dispatcherId);
        console.info('New actions `%s` for dispatcher `%s`', id, dispatcherId);
        cache[id] = actions;
      }

      return actions;
    },

    /**
     * Retrieve an Actions collection
     * 
     * @param  {String} id Id of the action collection
     * @return {Object} Action collection instance
     */
    get: function (id) {
      var actions = cache[id];

      if (!actions) {
        throw new Error('No actions for `' + id + '`. This is probably because the service where you created the actions has not been invoked by Angular yet.');
      }

      return actions;
    }
  };
};

ActionsUtil.$inject = ['$injector'];
module.exports = ActionsUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/lib/Actions.js